import React from 'react';
import styled from 'styled-components';
import { Accordion } from '@latitude/accordion';
import { Box } from '@latitude/box';
import { Heading3 } from '@latitude/heading';
import { FONT_FAMILY, BREAKPOINT } from '@latitude/core/utils/constants';
import { RatesList } from '@latitude/rates-list';
const RatesAndFees = props => {
  return /*#__PURE__*/React.createElement(Outer, {
    id: props.id,
    className: props.className
  }, /*#__PURE__*/React.createElement(Inner, {
    isResponsive: true
  }, /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, props.title || 'Rates, Fees and Conditions'), /*#__PURE__*/React.createElement(RatesList, props.ratesListProps), /*#__PURE__*/React.createElement(AccordionContainer, null, /*#__PURE__*/React.createElement(AccordionStyled, Object.assign({
    titleBgColor: "grey-light"
  }, props.accordionProps)))));
};
const Outer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RatesAndFees__Outer",
  componentId: "sc-1slm077-0"
})(["background-color:#f8f8f8;padding:40px 15px;@media (min-width:", "){padding:72px 0;}"], BREAKPOINT.LG);
const Inner = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RatesAndFees__Inner",
  componentId: "sc-1slm077-1"
})(["margin:0 auto;padding:0 15px;"]);
const Title = /*#__PURE__*/styled(Heading3).withConfig({
  displayName: "RatesAndFees__Title",
  componentId: "sc-1slm077-2"
})(["text-align:center;font-family:", ";font-weight:600;font-size:24px;color:#000;margin-bottom:24px;@media (min-width:", "){font-size:36px;line-height:40px;margin-bottom:48px;}"], FONT_FAMILY.TITLE, BREAKPOINT.LG);
const AccordionContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "RatesAndFees__AccordionContainer",
  componentId: "sc-1slm077-3"
})(["max-width:800px;margin:40px auto 0;"]);
const AccordionStyled = /*#__PURE__*/styled(Accordion).withConfig({
  displayName: "RatesAndFees__AccordionStyled",
  componentId: "sc-1slm077-4"
})([".accordion-custom .accordion-item__heading{background-color:#f3f3f3;}.accordion-custom .accordion-item__body{padding:0;}.accordion-custom .accordion__row{padding:5px 30px;background:white;border-bottom:1px solid #dae3e7;}.accordion-custom .accordion__row:last-child{border-bottom:0;}@media (min-width:", "){margin-top:48px;}.accordion__item button.link-block{:focus{outline-color:#ddd;}}"], BREAKPOINT.LG);
export default RatesAndFees;